// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b35c4dd0","186":"c4815048","225":"c9f16bae","335":"880c7142","344":"0989e63a","372":"589f63ae","738":"6632c046","841":"2e086b33","856":"afd2f7a8"}[chunkId] + ".chunk.js";
};